import { errorCodeOf, isSessionExpired } from "./gatewayErrors";

// One MPIN check for the /mpin-verify screen, whichever endpoint the situation needs.
//
//  mode "unlock": crypto session lapsed → merchant validate-mpin ({valid, lockedForSeconds}).
//  mode "reauth": login token used from a new IP → gateway /auth/reauth ({success}).
//
// Both can be true at once (idle long enough for the session to lapse AND on another network). The
// gateway then answers the unlock call itself with GWB001, so the same MPIN is replayed against
// /auth/reauth instead of making the user type it twice.
//
// `unlock` / `reauth` are injected (they need the token, the mid and React hooks); `initSession` is
// called once if the crypto session expired mid-way and the call is retried.
//
// Resolves to { ok, message, lockedForSeconds }. A wrong MPIN, expired token etc. are thrown as the
// original axios error for describeMpinError() to explain.
export async function verifyMpin({ mode, unlock, reauth, initSession }) {
  const attempt = async (which) => {
    try {
      if (which === "reauth") {
        const d = await reauth();
        return { ok: !!d?.success, message: d?.message };
      }
      const d = await unlock();
      return { ok: !!d?.valid, message: d?.message, lockedForSeconds: d?.lockedForSeconds };
    } catch (err) {
      if (which === "unlock" && errorCodeOf(err) === "GWB001") return attempt("reauth");
      throw err;
    }
  };

  let retried = false;
  for (;;) {
    try {
      return await attempt(mode);
    } catch (err) {
      if (!retried && initSession && isSessionExpired(err)) {
        retried = true;
        await initSession();
        continue;
      }
      throw err;
    }
  }
}
